import { gsap } from "gsap";

// ---------------- Скрытие элемента
/*
	1) Скрытие контента
	2) Уменьшение высоты контейнера
	3) Сохранение overflow для скрытого состояния

	Опции: 
		- duration (число) - длительность анимации, 
		- ease (строка) - функция ease
*/
type HiddenElementOptions = {
  duration?: number;
  ease?: string;
};
export const hideElement = (
  container: HTMLElement,
  options: HiddenElementOptions = {}
) => {
  const content = container.firstElementChild as HTMLElement | null;
  if (!content) return null;

  const { duration = 0.15, ease = "power2.inOut" } = options;

  const timeline = gsap.timeline();

  timeline.to(content, {
    opacity: 0,
    duration: 0.15,
    ease: "none",
  });

  timeline.to(container, {
    height: 0,
    duration,
    ease,
  });

  return timeline;
};
